import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useLang } from "@/lib/i18n";
import { api, errorMessage, thumbUrl } from "@/lib/api";
import { ExtrasTags } from "@/components/CartLine";

export const AdminLine = ({ line, index, orderNumber }) => {
  const { t, money, num } = useLang();
  const [busy, setBusy] = useState(false);
  const fileName = `${orderNumber}-L${index + 1}-${line.print_type.toUpperCase()}-${line.width}x${line.height}in-x${line.quantity}.png`;

  const download = async () => {
    setBusy(true);
    try {
      const res = await api.get(`/admin/uploads/${line.upload_id}/download`, { responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      a.click();
      URL.revokeObjectURL(url);
    } catch (e) {
      toast.error(errorMessage(e, t));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex flex-col gap-4 border-b border-white/10 py-5 last:border-0 sm:flex-row" data-testid={`admin-line-${index}`}>
      <div className="checker grid h-28 w-28 shrink-0 place-items-center overflow-hidden rounded p-1.5">
        <img src={thumbUrl(line.upload_id)} alt="" className="max-h-full max-w-full object-contain" />
      </div>
      <div className="flex-1 text-sm">
        <p className="flex flex-wrap items-center gap-2 text-base font-extrabold">
          <span className="text-slate-500">#{index + 1}</span>
          <span className={`rounded px-1.5 py-0.5 text-[10px] ${line.print_type === "dtf" ? "bg-ruby" : "bg-cap"}`}>{t(`common.${line.print_type}`)}</span>
          <span className="font-mono-num">{num(line.width)}" × {num(line.height)}"</span>
          <span className="text-slate-400">× {line.quantity}</span>
        </p>
        <p className="mt-1 break-all text-xs text-slate-500">{line.filename} · {line.width_px}×{line.height_px}px · {line.dpi ? `${line.dpi} dpi` : "dpi ?"}</p>
        <div className="mt-2"><ExtrasTags line={line} /></div>
        {line.notes && <p className="mt-2 rounded bg-white/5 p-2 text-slate-300"><span className="font-bold">{t("admin.customer_notes")}: </span>{line.notes}</p>}
        <p className="mt-2 font-mono-num text-xs text-slate-400">
          {num(line.total_area)} in² @ {money(line.ta_rate ?? line.rate, 3)} TA · {t("admin.ta_cost")} {money(line.cost)} · {t("admin.your_profit")} <span className="text-emerald-400">{money(line.profit)}</span> · {t("admin.total")} {money(line.line_total)}
        </p>
      </div>
      <button onClick={download} disabled={busy} className="btn-ghost h-fit shrink-0 px-4 py-2 text-xs" data-testid={`admin-download-${index}`}>
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4" />} {t("admin.download")}
      </button>
    </div>
  );
};
